import get from '../../../../../fns/http/get'
import getHeaders from '../headers/index'

const loadGeoData = (engineId, { urls, locale, headers, sessionId, responseProxy }) => {
    return get(`${urls.base.se}/search/geodata/${engineId}`, null, getHeaders({ locale, headers }), { responseProxy })
}
export default loadGeoData
